import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/store'
import * as session from './api/authSession'
import './registerServiceWorker'
import vuetify from './plugins/vuetify'
import SweetAlertVuetify from './plugins/SweetAlertVuetify'
import './plugins/vee-validate'
import './filters'
import jsme from './plugins/jsme' // TODO: remove this plugin in the future

import { ValidationObserver } from 'vee-validate'
import VTextFieldValidatable from './components/Inputs/VTextFieldValidatable'
import VAutocompleteValidatable from './components/Inputs/VAutocompleteValidatable'
import VTextareaValidatable from './components/Inputs/VTextareaValidatable'
import VCheckboxValidatable from './components/Inputs/VCheckboxValidatable'

Vue.config.productionTip = false

Vue.component('validation-observer', ValidationObserver)
Vue.component('v-text-field-validatable', VTextFieldValidatable)
Vue.component('v-autocomplete-validatable', VAutocompleteValidatable)
Vue.component('v-textarea-validatable', VTextareaValidatable)
Vue.component('v-checkbox-validatable', VCheckboxValidatable)

Vue.use(jsme)
Vue.use(SweetAlertVuetify, vuetify)

function syncSession() {
	const token = session.getToken()
	if (!token) {
		store.commit('auth/LOGOUT')
		return
	}
	store.commit('auth/SET_TOKEN', token)
	try {
		store.commit('auth/SET_USER', JSON.parse(localStorage.getItem('user') || '{}'))
	} catch {
		store.commit('auth/SET_USER', {})
	}
}

// The token key is authoritative, including when older vuex-persist data
// contains an obsolete token. Keep tabs and Vuex in sync after rotation.
syncSession()
window.addEventListener(session.SESSION_CHANGED, syncSession)
window.addEventListener('storage', event => {
	if (!event.key || ['token', 'user'].includes(event.key)) syncSession()
})
window.addEventListener(session.SESSION_EXPIRED, () => {
	if (['login', 'forgot-password', 'reset-password'].includes(router.currentRoute.name)) return
	const redirect = router.currentRoute.fullPath
	router.replace({ name: 'login', query: { redirect } }).catch(() => {})
})

new Vue({
	router,
	store,
	vuetify,
	render: h => h(App),
}).$mount('#app')
